t = require('views/internal/teacup-with-helpers')('manage_members_select_role')

module.exports = ->
  t.ul '.pop-over-list', ->
    t.mustacheBlock 'showAdmin', ->
      t.li ->
        t.a '.js-invite.js-select-admin', { href: '#' }, ->
          t.format 'admin-roletext-admin', { roleText_admin: t.mustacheVar('roleText_admin') }
    t.li ->
      t.a '.js-invite.js-select-member', { href: '#' }, ->
        t.format 'normal-roletext-normal', { roleText_normal: t.mustacheVar('roleText_normal') }
    t.mustacheBlock 'showObserver', ->
      t.li ->
        t.a '.js-invite.js-select-observer', { href: '#' }, ->
          t.format 'observer'
          t.icon 'business-class'
          t.span '.sub-name', ->
            t.text t.mustacheVar('roleText_observer')



// WEBPACK FOOTER //
// ./app/scripts/views/templates/manage_members_select_role.coffee